import { linkStyles } from './styles';
import { IDummyProps } from './types';
import { styled } from '../../Themes';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import { StyleObject } from 'styletron-react';
import { TSize } from '../Link/types';

export const StyledElementWithCustomStyle = ({
	theme,
	size,
}: {
	theme: IDummyProps & { $theme: typeof Theme };
	size: TSize;
}) =>
	styled<IDummyProps, 'a', typeof Theme>(
		'a',
		({ $theme, size = 'default' }): StyleObject => {
			return linkStyles({ disabled: false, theme: $theme, size }) as StyleObject;
		},
	);

export const StyledLinkAsButton = styled<IDummyProps, 'button', typeof Theme>(
	'button',
	({ $theme, size = 'default' }): StyleObject => {
		return linkStyles({ disabled: false, theme: $theme, size }) as StyleObject;
	},
);
